/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagesearchplaceholder3Inputs */

const en_ticketpagesearchplaceholder3 = /** @type {(inputs: Ticketpagesearchplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name, email or order number`)
};

const de_ticketpagesearchplaceholder3 = /** @type {(inputs: Ticketpagesearchplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name, E-Mail oder Bestellnummer`)
};

/**
* | output |
* | --- |
* | "Name, email or order number" |
*
* @param {Ticketpagesearchplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagesearchplaceholder3 = /** @type {((inputs?: Ticketpagesearchplaceholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagesearchplaceholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagesearchplaceholder3(inputs)
	return de_ticketpagesearchplaceholder3(inputs)
});
export { ticketpagesearchplaceholder3 as "ticketPageSearchPlaceholder" }